import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSupplierApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getSupplierListApi = createAsyncThunk('getSupplierList', async (payload) => {
  // console.log('payload', payload);
  return await getSupplierApi(payload);
});

const getSupplierListSlice = createSlice({
  name: 'getSupplierList', // Unique Name
  initialState,
  reducers: {
    getSupplierListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierListApi.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getSupplierListApi.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getSupplierListApi.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getSupplierListReset } = getSupplierListSlice.actions;

export default getSupplierListSlice.reducer;
